import React from "react";
import { ModuleI, LessonI } from "../../../types";
import { useGetLessons } from "../../../api/queries";
import Combobox from "../../../componentLibrary/Combobox";
import Spinner from "../../../componentLibrary/Spinner";

const LessonSelect = ({
  module,
  setModule,
  disabled = false,
}: {
  module: ModuleI;
  setModule: React.Dispatch<React.SetStateAction<ModuleI>>;
  disabled?: boolean;
}) => {
  const { data: lessons, isError, isLoading } = useGetLessons();
  const handleAddLesson = (optionSelected) => {
    if (!optionSelected.value) return;

    const lessonExists = module.lessons.some(
      (lesson: LessonI) => lesson._id === optionSelected.value,
    );

    if (!lessonExists) {
      const lesson = lessons.find(
        (lesson) => lesson._id === optionSelected.value,
      );
      setModule({
        ...module,
        lessons: [...module.lessons, lesson],
      });
    } else {
      alert("This lesson has already been added.");
    }
  };

  if (isLoading) return <Spinner className="mx-auto" />;
  if (isError || !lessons) return <div>Error</div>;

  return (
    <div className="flex flex-row w-full space-x-2 mb-2">
      <Combobox
        placeholder="Select a Lesson"
        options={lessons.map((lesson) => ({
          label: lesson.title,
          value: lesson._id,
        }))}
        onChange={(option) => {
          handleAddLesson(option);
        }}
        value={{ value: "", label: "" }}
        disabled={disabled}
      />
    </div>
  );
};

export default LessonSelect;
